<nav mat-tab-nav-bar [color]="'accent'">
  <a mat-tab-link [routerLink]="[]" fragment="opkraevninger" [class.active]="page == 'opkraevninger'">Opkrævninger</a>
  <a mat-tab-link [routerLink]="[]" fragment="eftersyn" [class.active]="page == 'page'">Eftersyn</a>
</nav>

<!-- <div class="sectionbar">
    <nav mat-tab-nav-bar>
      <a mat-tab-link [routerLink]="" fragment="opkraevninger" [class.active]="page == 'opkraevninger'">Opkrævninger</a>
      <a mat-tab-link [routerLink]="" fragment="eftersyn" [class.active]="page == 'eftersyn'"> Eftersyn </a>
    </nav>
  </div> -->
